import BookingFrom from "../components/BookingForm";
import Features from "../components/urbanianavacabsfeatures"
import LuxuryMobility from "../components/LuxuryMobility";
import SafetySection from "../components/SafetyCards";
import GogoCabFeatures from "../components/GogoCabFeatures";
import TestimonialSlider from "../components/TestimonialSlider";
import ForceUrbaniaRental from "../components/ForceUrbaniaRental"
import { Helmet } from "react-helmet";
import TempoTravellerPage from "../components/TempoTravellerPage"
import Frequentlyasked from "../components/Frequentlyasked"

const HomePage = () => {
    return (
        <div>
          <>
      <Helmet>
        <title>Force Urbania Booking Bangalore | 9/12/16 Seater Luxury Van Rental - Urbania Nava Cabs</title>
        <meta 
          name="description" 
          content="✅ Book Force Urbania 9/12/16 seater luxury van in Bangalore. AC, push-back seats, entertainment system. Perfect for corporate events, family trips, wedding functions. Call +91 99647 58999"
        />
        <meta name="keywords" content="force urbania booking bangalore, urbania van rental, 16 seater urbania, 12 seater urbania bangalore, 9 seater luxury van, corporate transport bangalore, wedding car rental bangalore" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Force Urbania Rental Service",
            "provider": {
              "@type": "LocalBusiness",
              "name": "Urbania Nava Cabs",
              "telephone": "+919964758999"
            },
            "areaServed": {
              "@type": "City",
              "name": "Bangalore"
            },
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Urbania Vehicle Packages",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Force Urbania 16 Seater Rental",
                    "description": "Luxury 16 seater AC van with push-back seats"
                  },
                  "priceSpecification": {
                    "@type": "UnitPriceSpecification",
                    "priceCurrency": "INR",
                    "price": "18-25",
                    "unitCode": "KMT"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Force Urbania 12 Seater Rental",
                    "description": "Premium 12 seater AC van with entertainment system"
                  },
                  "priceSpecification": {
                    "@type": "UnitPriceSpecification",
                    "priceCurrency": "INR",
                    "price": "16-22",
                    "unitCode": "KMT"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Force Urbania 9 Seater Rental",
                    "description": "Compact 9 seater luxury van for executive travel"
                  },
                  "priceSpecification": {
                    "@type": "UnitPriceSpecification",
                    "priceCurrency": "INR",
                    "price": "14-20",
                    "unitCode": "KMT"
                  }
                }
              ]
            }
          })}
        </script>
      </Helmet>
            <BookingFrom />
            <Features />
            <LuxuryMobility />
            <GogoCabFeatures />
            <SafetySection />
            <ForceUrbaniaRental/>
            <TestimonialSlider/>
            <TempoTravellerPage/>
            <Frequentlyasked/>
            </>
        </div>
    );
}
export default HomePage;